import { Typography, Box } from '@mui/material';
import {
  actionTabs,
  actionTabsIcons,
  ANNOTATIONS_TAB,
  SLIDES_LIST_TAB,
} from 'components/OrderSlidesList/SlideActionTabs/constants';
import { useStyles } from 'components/OrderSlidesList/SlideActionTabs/ActionTabsHeader/styles';
import { memo, useMemo } from 'react';

export const TabsHeader = ({
  activeTab,
  setActiveTab,
  showList,
  disabledTabs,
  isDisabled = false,
  isMultipleSelected,
}) => {
  const { classes } = useStyles();

  const tabs = useMemo(
    () =>
      Object.keys(actionTabs).filter(
        (tab) =>
          (tab !== SLIDES_LIST_TAB || showList) &&
          (tab !== ANNOTATIONS_TAB || !isMultipleSelected),
      ),
    [showList, isMultipleSelected],
  );

  const tabClassName = (tab) =>
    actionTabs[tab] === activeTab
      ? `${classes.tab} ${classes.activeTab}`
      : classes.tab;

  const isTabDisabled = (tab) => disabledTabs.includes(actionTabs[tab]);

  const handleTabClick = (tab) => {
    if (!isTabDisabled(tab)) {
      setActiveTab(actionTabs[tab]);
    }
  };

  const headerClass = `${classes.root} ${
    isDisabled ? classes.disabledTabHeader : ''
  }`;

  return (
    <Box className={headerClass}>
      {tabs.map((tab) => (
        <Box
          className={`${tabClassName(tab)} ${
            isTabDisabled(tab) ? classes.disabledTab : ''
          }`}
          key={tab}
          title={actionTabs[tab]}
          onClick={() => handleTabClick(tab)}
          disabled={disabledTabs.includes(actionTabs[tab])}
          id={`actionTab-${tab}`}
        >
          {actionTabsIcons[tab]}
          <Typography component="span" className={classes.label}>
            {actionTabs[tab]}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export const ActionTabsHeader = memo(TabsHeader);
